import { createContext } from 'react';
const initialState = {
    triggerLoader: false,
    handleTriggerLoader:(trigger=null)=>{}
}

const LoaderContext = createContext(initialState);


export default LoaderContext;